import { Navigate, Outlet } from 'react-router-dom';
import MainSitebar from '../MainSitebar';
import MainHeader from '../MainHeader';
import { useState } from 'react';
import Cookies from "js-cookie";

const DepartmentLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const departmentUserID = Cookies.get("NIGHT_EYE_USER_ID")

  return (
    <>
      {departmentUserID ?
        <div className="flex h-screen w-full overflow-hidden">
          {/* Mobile Sidebar (drawer/overlay) */}
          <div
            className={`
          fixed inset-0 z-50 transition-all duration-300 md:hidden
          ${mobileMenuOpen ? 'visible' : 'invisible'}
        `}
          >
            {/* Backdrop */}
            <div
              className={`
            absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300
            ${mobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}
          `}
              onClick={() => setMobileMenuOpen(false)}
            />

            {/* Sidebar drawer - slides from left */}
            <aside
              className={`
            absolute top-0 bottom-0 left-0 z-50 w-72 bg-white dark:bg-slate-900 
            border-r border-slate-200 dark:border-slate-800
            transform transition-transform duration-300 ease-in-out
            ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
          `}
            >
              <MainSitebar mobileMode onClose={() => setMobileMenuOpen(false)} />
            </aside>
          </div>

          {/* Desktop Sidebar - always visible */}
          <div className="hidden md:block md:w-64 md:flex-shrink-0">
            <MainSitebar />
          </div>

          {/* Main content area */}
          <div className="flex-1 w-full flex flex-col min-h-screen">
            <MainHeader
              onMenuToggle={() => setMobileMenuOpen(true)}
              isMobileMenuOpen={mobileMenuOpen}
            />
            <main className="flex-1 overflow-auto bg-background-light dark:bg-background-dark">
              <Outlet />
            </main>
          </div>
        </div> : <Navigate to={"/DepartmentLogin"} />}
    </>
  );
};

export default DepartmentLayout;




// import { Outlet } from 'react-router-dom'
// import MainSitebar from '../MainSitebar'
// import MainHeader from '../MainHeader'

// const DepartmentLayout = () => {
//     return (
//         <div className="flex h-screen w-full overflow-hidden">
//             {/* Sidebar */}
//             <MainSitebar />
//             <main className="flex-1 flex flex-col  h-full relative overflow-hidden bg-background-light dark:bg-background-dark">
//                 <MainHeader />
//                 <Outlet />
//             </main>
//         </div>
//     )
// }

// export default DepartmentLayout
